import { XIcon, IconButton } from 'stubben-edge-unified-frontend-react-components';
import type { AppliedSortTag } from './buildAppliedSortTags';

type Props = {
  tags: AppliedSortTag[];
  onRemove: (field: string) => void;
  testIdentifierPrefix: string;
};

/**
 * Horizontally scrollable chips for active table sorts (filter drawer header).
 */
export function AppliedSortTags({
  tags,
  onRemove,
  testIdentifierPrefix
}: Props) {
  if (tags.length === 0) return null;

  return (
    <div
      className="mb-4 min-w-0"
      data-testid={`${testIdentifierPrefix}-applied-sorts`}
    >
      <p className="mb-2 text-sm font-medium text-gray-700">Applied sort</p>
      <div className="flex max-w-full gap-2 overflow-x-auto pb-1">
        <div className="flex w-max flex-nowrap items-center gap-2">
          {tags.map((tag) => (
            <span
              key={`${tag.field}-${tag.direction}`}
              className="inline-flex shrink-0 items-center rounded-lg bg-primary-100 px-1 py-0.5 text-primary"
              data-testid={`${testIdentifierPrefix}-sort-tag-${tag.field}`}
            >
              <span className="inline-flex space-x-1 px-1 py-0.5 text-left text-xs leading-none">
                <span className="font-medium">Sort:</span>
                <span className="whitespace-nowrap font-semibold">
                  &quot;{tag.label}&quot;
                </span>
              </span>
              <IconButton
                size="sm"
                mode="ghost"
                testIdentifier={`${testIdentifierPrefix}-sort-tag-${tag.field}-remove`}
                onClick={() => onRemove(tag.field)}
              >
                <XIcon size={16} className="text-primary" />
              </IconButton>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
